import { useState } from 'react';
import { useParams, useNavigate, useSearchParams } from 'react-router-dom';
import { V2Button } from '@sakhtar/design-system/react';
import { tenantBasePath } from '../../lib/tenant.js';
import { GuidedImportView } from './GuidedImportView.js';
import { OpeningImportReview } from './OpeningImportReview.js';
import { DatasetImportView } from './DatasetImportView.js';

/**
 * Primary /data flow uses the production design-system components for five guided
 * packs and one server workspace. Legacy single-table Import remains a secondary
 * action. Staging and relation approval are separate from supported master-data commits.
 */
export function ImportExportPage() {
  const { slug } = useParams<{ slug: string }>();
  const navigate = useNavigate();
  const [search] = useSearchParams();
  const openingId = search.get('opening');
  const base = slug ? tenantBasePath(slug) : '';
  const [advanced, setAdvanced] = useState(false);
  if (!slug) return null;
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
      <div className="sk-breadcrumb">
        <span>تنظیمات سازمان</span>
        <span>/</span>
        <b>ورود اطلاعات</b>
      </div>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          gap: 12,
          flexWrap: 'wrap',
        }}
      >
        <h1
          style={{
            margin: 0,
            fontSize: 20,
            fontWeight: 700,
            color: 'var(--sk-fg)',
          }}
        >
          ورود اطلاعات به ساختار
        </h1>
        {!advanced && !openingId ? (
          <V2Button variant="ghost" onClick={() => setAdvanced(true)}>
            ورود تک‌جدولی
          </V2Button>
        ) : null}
      </div>
      {openingId ? (
        <OpeningImportReview key={`${slug}:${openingId}`} base={base} batchId={openingId} />
      ) : advanced ? (
        <DatasetImportView slug={slug} base={base} onBack={() => setAdvanced(false)} />
      ) : (
        <GuidedImportView slug={slug} base={base} onBack={() => navigate(`${base}/setup`)} />
      )}
    </div>
  );
}
